// Resolve a goal's progress_pct after a milestone toggle (BUG-002/008).
//
// The server returns the AUTHORITATIVE progress_pct — a 50/50 task+milestone
// blend. GoalsScreen used to substitute a milestone-ONLY optimistic value
// (completedCount / total milestones), which diverges from the blend and makes
// the progress bar visibly jump when the debounced refresh lands. Prefer the
// server value; fall back to the current value only when the server value is
// absent or not a finite number. (0 is a valid server value, not a fallback.)
export function resolveGoalProgress(
  serverPct: number | null | undefined,
  fallbackPct: number
): number {
  return typeof serverPct === "number" && Number.isFinite(serverPct)
    ? serverPct
    : fallbackPct;
}
